import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
import { jDate } from '../../utils/formatTime';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const startDate = new Date();
startDate.setMonth(0, 1);

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  params: {
    type: 'sale',
    group: '',
    date_after: jDate(startDate),
    date_before: jDate(new Date()),
  },
};

const slice = createSlice({
  name: 'reportSale',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET REPORT
    getReportSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams } = slice.actions;

// ----------------------------------------------------------------------

export function getReport(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/report', {
        params,
      });
      dispatch(slice.actions.getReportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
